import useScreenSize from "../../../hooks/useScreenSize";
import Strength from "./Strength";
import Style from "./Strengths.module.css";
import StrengthsCarousel from "./StrengthsCarousel";
import { useI18n } from "../../../i18n/I18nContext";

const strengthVisuals = [
  { boxColor: "#003CA2", imageSrc: "/knowledge.webp" },
  { boxColor: "#00A2FF", imageSrc: "/responsibility.webp" },
  { boxColor: "#00CBFF", imageSrc: "/teamwork.webp" },
  { boxColor: "#035DCB", imageSrc: "/leadership.webp" },
];

const StrengthsSection = () => {
  const { isSmallSize, isMediumSize } = useScreenSize();
  const { copy } = useI18n();

  const isMobile = isSmallSize || isMediumSize;

  const strengths = copy.home.strengths.items.map((strength, index) => ({
    ...strength,
    ...strengthVisuals[index],
  }));

  return (
    <div className={Style["strengths-section-wrapper"]}>
      <h2>{copy.home.strengths.title}</h2>
      <div>
        {isMobile ? (
          <StrengthsCarousel items={strengths} />
        ) : (
          strengths.map((s) => {
            return (
              <Strength
                key={s.heading}
                heading={s.heading}
                text={s.text}
                boxColor={s.boxColor}
                imageSrc={s.imageSrc}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

export default StrengthsSection;
